// Financesidebar.js
// Shared "Finances" sidebar for posting.js and statements.js
// Desktop AUR mobile dono par dono pages mein bilkul ek jaisa dikhta hai
// (same width, height, spacing, border, font, links).
// Component sidebar ke saath content column ki width bhi set karta hai,
// taake mobile par dono pages ka layout ek jaisa rahe.
import React from "react";
import { Link } from "react-router-dom";

// Statement page ki purani CSS (statements.css) in classes ko target karti hai,
// is liye variant="statement" par ye extra classes bhi lagti hain.
const EXTRA = {
  posting: { box: "", title: "", wrap: "", link: "" },
  statement: {
    box: " statement-sidebar",
    title: " statement-sidebar-title",
    wrap: " statement-sidebar-link-wrapper",
    link: " statement-sidebar-link",
  },
};

const FinanceSidebar = ({ variant = "posting" }) => {
  const x = EXTRA[variant] || EXTRA.posting;

  return (
    <>
      <div className={`col-md-2 finance-sidebar${x.box}`}>
        <h2 className={`finance-title${x.title}`}>Finances</h2>

        <div>
          <div className={`finance-link-wrapper${x.wrap}`}>
            <Link to="/posting" className={`finance-link${x.link}`}>
              Postings
            </Link>
          </div>

          <div className={`finance-link-wrapper${x.wrap}`}>
            <Link to="/statement" className={`finance-link${x.link}`}>
              Statements
            </Link>
          </div>
        </div>
      </div>

      <style>{`
        /* ───────── DESKTOP (>= 769px) ───────── */
        @media (min-width: 769px) {
          div.row > div.finance-sidebar.col-md-2 {
            border-right: 1px solid #004aad !important;
            padding-top: 20px !important;
            min-height: calc(100vh - 200px) !important;
          }

          div.row > div.finance-sidebar .finance-title {
            margin: 0 0 8px 30px !important;
            font-weight: 600 !important;
            color: #333 !important;
          }

          div.row > div.finance-sidebar .finance-link-wrapper {
            margin: 0 0 10px 0 !important;
          }

          div.row > div.finance-sidebar .finance-link {
            display: inline-block !important;
            margin: 0 0 0 40px !important;
            text-decoration: none !important;
            color: #004aad !important;
            font-weight: 500 !important;
          }
        }

        /* Tablet (769px - 992px): dono pages mein same font */
        @media (min-width: 769px) and (max-width: 992px) {
          div.row > div.finance-sidebar .finance-title { font-size: 20px !important; }
          div.row > div.finance-sidebar .finance-link { font-size: 14px !important; }
        }

        /* ───────── MOBILE (<= 768px) ───────── */
        @media (max-width: 768px) {
          div.row > div.finance-sidebar.col-md-2 {
            display: block !important;
            flex: 0 0 58px !important;
            width: 58px !important;
            max-width: 58px !important;
            min-width: 58px !important;
            align-self: stretch !important;
            min-height: 0 !important;
            margin: 0 !important;
            padding: 4px 1px !important;
            border-right: 1px solid #004aad !important;
            overflow: hidden !important;
          }

          div.row > div.finance-sidebar.col-md-2 ~ div.col-md-10 {
            flex: 0 0 calc(100% - 58px) !important;
            width: calc(100% - 58px) !important;
            max-width: calc(100% - 58px) !important;
            min-width: 0 !important;
          }

          div.row > div.finance-sidebar .finance-title {
            margin: 0 0 6px 3px !important;
            padding: 0 !important;
            font-size: 10px !important;
            line-height: 1.2 !important;
            font-weight: 600 !important;
            color: #333 !important;
            white-space: nowrap !important;
          }

          div.row > div.finance-sidebar .finance-link-wrapper {
            margin: 0 0 4px 0 !important;
            padding: 0 !important;
            line-height: 1.3 !important;
          }

          div.row > div.finance-sidebar .finance-link {
            display: inline-block !important;
            margin: 0 0 0 3px !important;
            padding: 0 !important;
            font-size: 8.5px !important;
            line-height: 1.3 !important;
            font-weight: 500 !important;
            text-decoration: none !important;
            color: #004aad !important;
            white-space: nowrap !important;
          }
        }

        /* Small mobile (<= 576px) */
        @media (max-width: 576px) {
          div.row > div.finance-sidebar.col-md-2 {
            flex: 0 0 52px !important;
            width: 52px !important;
            max-width: 52px !important;
            min-width: 52px !important;
          }

          div.row > div.finance-sidebar.col-md-2 ~ div.col-md-10 {
            flex: 0 0 calc(100% - 52px) !important;
            width: calc(100% - 52px) !important;
            max-width: calc(100% - 52px) !important;
          }

          div.row > div.finance-sidebar .finance-title { font-size: 8.5px !important; }
          div.row > div.finance-sidebar .finance-link { font-size: 7.5px !important; }
        }

        /* Extra small (<= 400px) */
        @media (max-width: 400px) {
          div.row > div.finance-sidebar.col-md-2 {
            flex: 0 0 46px !important;
            width: 46px !important;
            max-width: 46px !important;
            min-width: 46px !important;
          }

          div.row > div.finance-sidebar.col-md-2 ~ div.col-md-10 {
            flex: 0 0 calc(100% - 46px) !important;
            width: calc(100% - 46px) !important;
            max-width: calc(100% - 46px) !important;
          }

          div.row > div.finance-sidebar .finance-title {
            font-size: 8px !important;
            margin-left: 2px !important;
          }

          div.row > div.finance-sidebar .finance-link {
            font-size: 7px !important;
            margin-left: 2px !important;
          }
        }
      `}</style>
    </>
  );
};

export default FinanceSidebar;